const configMapa = {
    clickableIcons: false,
    streetViewControl: false,
    panControlOptions: false,
    gestureHandling: "cooperative",
    mapTypeControl: false,
    zoom: 15,
    minZoom: 7,
    maxZoom: 20
}
export { configMapa}